import cn from 'classnames';

type TInput = JSX.IntrinsicElements['input'];

export interface Label extends Pick<TInput, 'required'> {
  as?: 'label' | 'legend';
  htmlFor?: JSX.IntrinsicElements['label']['htmlFor'];
  label?: JSX.Element | string;
  labelSuffix?: JSX.Element | string;
  showAsterisk?: boolean;
  variant?: 'inline' | 'input-border' | 'primary' | 'task' | 'v1' | 'v2';
}

export function Label({
  as: LabelComponent = 'label',
  htmlFor,
  label,
  labelSuffix,
  required,
  showAsterisk = true,
  variant,
}: Label) {
  if (!label) {
    return null;
  }

  return (
    <LabelComponent
      className={cn('block pb-2', {
        'flex items-center gap-x-2': labelSuffix,
        'text-14/100% font-medium text-gray-800': variant !== 'task',
        'text-heading-25 text-gray-500': variant === 'task',
      })}
      htmlFor={htmlFor}
    >
      {label}
      {required && showAsterisk && '*'}
      {labelSuffix}
    </LabelComponent>
  );
}
